import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { ManoObra } from '../../../models/ManoObra';
@Injectable({
  providedIn: 'root'
})
@Injectable()

export class ArticuloService
{
  private host : string = environment.articulosWSBase;

  constructor(private http: HttpClient){}

  //devuelve un array de las marcas disponibles
  public getMarcas(token:string):Promise<articulosWsMarca[]>
  {
    let url:string = this.host + "/Marcas/getMarca";

    // Set the request headers with the authorization token
    let headers = new HttpHeaders({
      'Authorization': 'Bearer '+token
    });

    return new Promise<articulosWsMarca[]>((resolve, reject) =>
    {
      this.http.post(url,null,{headers})
      .subscribe
      ({
        next(res:any)
        {
          resolve(res);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  //retorna los modelos de una marca determinada
  public getModelosMarca(token:string,marca:string):Promise<articulosWsMarca[]>
  {
    let url:string = this.host + "/Marcas/getModelo";
    //marca = "'"+marca.toUpperCase().trimEnd()+"'";
    marca = '"'+marca.toUpperCase().trimEnd()+'"';
    // Set the request headers with the authorization token
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    return new Promise<articulosWsMarca[]>((resolve, reject) =>
    {
      this.http.post(url,marca,httpOptions)
      .subscribe
      ({
        next(res:any)
        {
          resolve(res);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  public getAnno(token:string,marca:string,modelo:string):Promise<number[]>
  {
    let url:string = this.host + "/Marcas/getAny";
    const httpOptions =
    {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let params = {marca:marca,modelo:modelo};

    return new Promise<number[]>((resolve, reject) =>
    {
      this.http.post(url,params,httpOptions)
      .subscribe
      ({
        next(res:any)
        {
          resolve(res);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        },
      });
    });
  }
  public getPuertas(token:string,marca:string,modelo:string,anyio:number):Promise<number[]>
  {
    let url:string = this.host + "/Marcas/getPuertas";
    const httpOptions =
    {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let params = {marca:marca,modelo:modelo,any:anyio.toString()};

    return new Promise<number[]>((resolve, reject) =>
    {
      this.http.post(url,params,httpOptions)
      .subscribe
      ({
        next(res:any)
        {
          resolve(res);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        }
      });
    });
  }
  /*
    Busca y retorna la Mano de obra de un artículo específico
    Ej de respuesta:
      [
        {
          "articulo": "99099003",
          "descripcion": "M.OBRA TURISMO PB-LU+KIT PEGAD"
        }
      ]
  */
  public getManoObraArticulo(token:string,articulo:string):Promise<ManoObra[]>
  {
    let url = this.host + "/Articulos/mano_obra";

    const httpOptions =
    {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
      .set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,'"'+articulo+'"',httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        },
      })
    });
  }

  public getStockArt(token:string,articulo:string,taller:number){
    let url = this.host+ "/Stocks/stockArt"

    const httpOptions =
      {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
          .set('Authorization', 'Bearer ' + token),
        params: new HttpParams({})
      };

    let arrayParam = {
      "articulo": articulo,
      "taller": taller
    };
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrayParam,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }

  public getInfoCrital(token:string, eurocode: string){
    let url:string = this.host + "/AnexoArticulo"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrParams =
      {
        parameters:
          [
            [
              {
                campo:"ref_eurocode",
                operacion:"=",
                valor:eurocode.toString()
              }
            ]
          ],
        select:["luna", "posicion", "derecho", "izquierdo"]
      };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(response)
          {
            resolve(response);
          },
          error(err)
          {
            reject(err);
          }
        });
    });
  }
}

export interface articulosWsMarca{marca:string,modelo:string}


